<div [id]="id()">
    <datiq-modal [settings]="settings" 
        [id]="id() + '-modal'" 
        (clickedCloseButton)="close()">
        <div datiq-modal-body class="flex flex-col ">
            @for (modalItem of modalData(); track modalItem.code){
            <button (click)="selectXMarket(modalItem)" class="!justify-start rounded-[4px] w-full bg-white hover:bg-dat-grey-050 cursor-pointer">
                <div class="grid grid-cols-[24px,1fr] gap-x-[10px] text-left font-medium text-black p-2 tracking-wide ">
                    <div class="w-6 h-6 rounded-[12px]" [style.background-color]="modalItem.fillColor"></div>
                    <div class="pt-[2px]">{{modalItem.name}}</div>
                </div>
            </button>
            }
        </div>
    </datiq-modal>
</div>